import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Nuevo modificador',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Info nutricional',
  },
  form: {
    modifier_groups: {
      label: 'Pertenece a grupos de modificadores',
    },
    name: {
      label: 'Nombre',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: 'Ref. {{integration}}',
      placeholder: 'p. ej. referencia SKU de HubRise',
      read_only_hint:
        'Editable solo si hay una integración HubRise conectada y la sincronización del menú está desactivada.',
    },
    price: {
      label: 'Precio base',
      placeholder: 'Opcional',
    },
    is_available: {
      label: 'En stock',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible en el menú',
      subtitle_on: 'Los clientes pueden ver esta opción',
      subtitle_off: 'Oculto para todos los clientes',
    },
    is_available_for_pickup: {
      label: 'Disponible para recogida',
      subtitle_on: 'Los clientes pueden pedirlo para recoger',
      subtitle_off: 'Oculto en el menú de recogida',
    },
    is_available_for_delivery: {
      label: 'Disponible para entrega',
      subtitle_on: 'Los clientes pueden pedirlo para entrega',
      subtitle_off: 'Oculto en el menú de entrega',
    },
  },
  availability: {
    title: 'Disponibilidad',
    helper:
      'La visibilidad es el interruptor principal. Desactiva un canal para ocultar esta opción a clientes de recogida o entrega sin eliminarla del menú.',
    status: {
      both: 'Ambos canales',
      pickup_only: 'Solo recogida',
      delivery_only: 'Solo entrega',
      hidden: 'Oculto',
      no_channels: 'Sin canales',
    },
    warning: {
      no_channels:
        'Esta opción es visible pero no está disponible en ningún canal: los clientes no podrán seleccionarla.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Solo recogida',
      delivery_only: 'Solo entrega',
      no_channels: 'Sin canales',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: '¡Cambios guardados con éxito!',
  },
};
